import { TColumnName } from "../types";
import {
  META_COLUMN_PREFIX,
  METHOD_COLUMN_PREFIX,
  METHOD_COLUMN_SUFFIX_X,
  PREDICTION_COLUMN_PREFIX,
} from "../constants";

class ColumnNameUtils {
  static getLabelForMethodX(columnName: TColumnName): string {
    return columnName
      .replace(METHOD_COLUMN_PREFIX, "")
      .replace(METHOD_COLUMN_SUFFIX_X, "");
  }

  static isPredictionForMethod(columnName: TColumnName, method: TColumnName) {
    return columnName.startsWith(
      PREDICTION_COLUMN_PREFIX + ColumnNameUtils.getLabelForMethodX(method)
    );
  }

  static isMetaForMethod(column: TColumnName, method: TColumnName) {
    return column.startsWith(
      META_COLUMN_PREFIX + ColumnNameUtils.getLabelForMethodX(method)
    );
  }

  static isMetaColumn(column: TColumnName) {
    return column.startsWith(META_COLUMN_PREFIX);
  }

  static getPredictionLabel(column: TColumnName, method: TColumnName) {
    const methodLabel = ColumnNameUtils.getLabelForMethodX(method);
    return column
      .replace(PREDICTION_COLUMN_PREFIX, "")
      .replace(methodLabel + "_", "");
  }

  static removePrefixes(column: TColumnName) {
    return column.replace(PREDICTION_COLUMN_PREFIX, "");
  }

  static getConScoreLabel(column: string) {
    return column.split("-")[1].split("_")[1];
  }
}

export default ColumnNameUtils;
